import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TvScriptLoaderService } from './services/tv-script-loader.service';

@NgModule({
  imports: [CommonModule],
  providers: [TvScriptLoaderService],
})
export class TvScriptModule {}
